import { barChartLabelFormatter } from "@/common/utils/barChartLabelFormatter";
import { DashboardComponentChartProps } from "@/features/company/types/dashboards/dashboardComponent.type";
import { Fragment } from "react";

const ValueComponent = ({
  chartData,
}: DashboardComponentChartProps) => {
  return (
    <div className="w-full h-full flex flex-col items-end justify-end p-4">
      {chartData?.series_settings && Object.entries(chartData?.series_settings).map(([key, data], index) => (
        <Fragment key={key}>
          <p
            className="text-3xl text-nowrap overflow-ellipsis overflow-hidden w-full"
            style={{
              color: data.color,
            }}
          >
            {barChartLabelFormatter(
              chartData?.data?.[index][key] as string ?? 0,
              data.format_parser,
            )}
          </p>
        </Fragment>
      ))}
    </div>
  );
}

export default ValueComponent;
